const ja = {
  layout: {
    cos_button: {
      phone: '電話番号',
      update_phone_number_message: '電話番号が正常に更新されました!'
    },
    time: {
      days: '日',
      hours: '時',
      mins: '分',
      secs: '秒',
      starts: '開始',
      starts_immediately: 'まもなく開始'
    },
    field: {
      host: 'ホスト'
    },
    copy: 'コピー'
  },
  validations: {
    email: 'メールアドレスが無効です',
    phone: 'は不正な値です',
    required_field: '（これ）は記入必須項目です'
  },
  mailer: {
    need_help: 'お困りですか？',
    stop_reminders: 'リマインダーをこれ以上受け取らない',
    cancel_registration: '登録をキャンセルする',
    report_abuse: '不正行為を報告'
  },
  datetime: {
    no_sessions: '利用可能なセッションがありません',
    empty_label: '日時'
  },
  errors: {
    verification_failed: '認証に失敗しました。もう一度お試しください。',
    session_unavailable: '選択された日時は既にご利用いただけません。別のセッションをお選びください。',
    challenge_email_mismatch: 'イベントに登録した際と同じメールアドレスでご登録ください。'
  }
}

export default ja
